const $inject = ['$q', 'dataService', 'perDiemService', '$timeout', '$rootScope', '$scope','$http'];

const lbaPerDiemCtrl = function ($q, dataService, perDiemService, $timeout, $rootScope, $scope, $http) {
  let vm = this;

  vm.setActiveTab = setActiveTab;
  vm.activeTab = "data";

  function setActiveTab(id)
  {
    vm.activeTab = id;
  }
 
};

lbaPerDiemCtrl.$inject = $inject;

export default lbaPerDiemCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaPerdiem/lbaPerDiemCtrl.js